/* eslint-disable no-console */
/**
 * Use this utility function to check the back end for specific feature flags based on the given params
 *
 * @param featureFlagKey
 * @param userEmail
 * @param callback
 * @param setLoading - Turn loading off
 */
let checkFeatureFlag = function(featureFlagKey, userEmail, callback, setLoading) {
	const featureFlagEndpoint = '/internal/dynamic-home-api/Ajax/Ajax.php?action=IsFeatureFlagEnabled';
	let featureData = {
		'featureFlag': featureFlagKey,
		'persistenceKey': userEmail,
		'attributes': {
			'emailAddress': userEmail
		}
	};

	fetch(featureFlagEndpoint, {
		method: 'POST',
		headers: new Headers({
			'Content-Type': 'application/json'
		}),
		body: JSON.stringify(featureData)
	})
		.then(response => response.json())
		.then(data => {
			if (typeof callback !== 'undefined' && typeof data.payload.isEnabled !== 'undefined') {
				callback(data.payload.isEnabled);
				setLoading(false);
				return true;
			} else {
				callback(false);
				setLoading(false);
				return false;
			}
		})
		.catch(error => console.error(error));
};

export default checkFeatureFlag;
